module.exports = __webpack_public_path__ + "static/media/stebbic0c0.85ce9f37.svg";